import SkeletonElement from "@/components/Skeleton/SkeletonElement";

interface PaginationSkeletonProps {
  variant?: "compact" | "default";
}

export default function PaginationSkeleton({ variant = "default" }: PaginationSkeletonProps) {
  return (
    <div className="flex items-start md:items-center justify-end flex-col md:flex-row sticky">
      {variant !== "compact" && (
        <div className="hidden sm:flex items-center mr-6">
          <span className="text-label-large mr-1 text-transparent">Rows per page:</span>
          <div className="w-[68px]">
            <SkeletonElement height="h-8" width="w-full" />
          </div>
        </div>
      )}
      <div className="flex items-center justify-center md:justify-end w-full md:w-fit gap-4">
        <div className="text-label-large">
          <SkeletonElement height="h-5" width="w-20" rounded="rounded" />
        </div>
        <div className="flex items-center gap-2">
          <SkeletonElement height="h-10" width="w-10" rounded="rounded" />
          <SkeletonElement height="h-10" width="w-10" rounded="rounded" />
        </div>
      </div>
    </div>
  );
}
